import React from "react";
import { GoalsExploreProvider } from "src/contexts/goalsExploreContext";
import GoalsExplore from "./index";

const GoalsExploreContainer = () => {
  return (
    <GoalsExploreProvider>
      <GoalsExplore />
    </GoalsExploreProvider>
  );
};

export default GoalsExploreContainer;
